/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Flyerresultalt2Inputs */

const en_flyerresultalt2 = /** @type {(inputs: Flyerresultalt2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generated flyer`)
};

const de_flyerresultalt2 = /** @type {(inputs: Flyerresultalt2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erstellter Flyer`)
};

/**
* | output |
* | --- |
* | "Generated flyer" |
*
* @param {Flyerresultalt2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const flyerresultalt2 = /** @type {((inputs?: Flyerresultalt2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Flyerresultalt2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_flyerresultalt2(inputs)
	return de_flyerresultalt2(inputs)
});
export { flyerresultalt2 as "flyerResultAlt" }